module.exports = "/fonts/vendor/@fontsource/inter/files/inter-latin-900-normal.woff2?b212a798db3b717b02ca67e3ca5c0bef";